import { Component, OnInit } from "@angular/core";

@Component({
  selector: "emptycomponent",
  template: "",
})
export class EmptyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
